import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useReminderType, ReminderType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<ReminderType>
      useData={useReminderType}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
